module.exports = __webpack_public_path__ + "img/dzzhd.672e1800.png";